import { ClinicPimsIntegrationFragment, PimsIntegrationCapability } from 'shared/types/graphql';

export function getHasPrescriptionCapabilities(integrations: ClinicPimsIntegrationFragment[] | null): boolean {
  const capabilities = integrations?.map((integration) => integration.capabilities).flat();
  const prescriptionCapability = capabilities?.find(
    (c) => c?.capability === PimsIntegrationCapability.Prescription && c.lastSyncedAt !== null,
  );
  return !!prescriptionCapability;
}
